import { Box } from "@mui/material";
import React from "react";

interface Props {
  /** Narrowest a tile may get before the grid drops to fewer columns. */
  minTileWidth: number;
  /** Space between the tiles, in px. */
  gap: number;
  /** Most columns the grid may use, however wide it gets. */
  maxColumns?: number;
  children: React.ReactNode;
}

/**
 * Lays tiles out in as many equal columns as fit (up to `maxColumns`), so the
 * same grid gives three columns on a wide screen and one on a phone without
 * per-breakpoint counts.
 */
export const OnboardingTileGrid = ({
  minTileWidth,
  gap,
  maxColumns,
  children,
}: Props) => {
  const columnMin = maxColumns
    ? `max(${minTileWidth}px, calc((100% - ${(maxColumns - 1) * gap}px) / ${maxColumns}))`
    : `${minTileWidth}px`;
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(${columnMin}, 1fr))`,
        // Every row as high as the tallest tile, so a tile with a two-line
        // subline does not leave its row taller than the others.
        gridAutoRows: "1fr",
        gap: `${gap}px`,
      }}
    >
      {children}
    </Box>
  );
};
